import { motion } from "framer-motion";

export function ExperienceCard({ exp, large = false, index = 0 }) {
  return (
    <motion.figure
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.08, ease: "easeOut" }}
      data-testid="experience-card"
      className={`mb-6 break-inside-avoid rounded-2xl border border-stone-200 bg-white p-7 ${
        large ? "sm:p-10" : "sm:p-8"
      }`}
    >
      <span
        aria-hidden
        className="block font-serif-display text-6xl leading-[0.6] text-[#1F3D2E]/25"
      >
        &ldquo;
      </span>
      <blockquote
        className={`mt-3 whitespace-pre-line leading-relaxed text-stone-700 ${
          large ? "text-lg" : "text-base"
        }`}
      >
        {exp.experience}
      </blockquote>
      {exp.advice ? (
        <p className="mt-4 border-l-2 border-[#8B6F3D]/50 pl-3 text-sm italic text-stone-500">
          {exp.advice}
        </p>
      ) : null}
      <figcaption className="mt-6 flex items-center gap-3">
        {exp.photo ? (
          <img
            src={exp.photo}
            alt={exp.display_name}
            className="h-11 w-11 rounded-full object-cover ring-1 ring-stone-200"
          />
        ) : (
          <span className="grid h-11 w-11 place-items-center rounded-full bg-[#F0EBE0] font-playfair text-[#8B6F3D]">
            {exp.display_name?.[0] || "\u2022"}
          </span>
        )}
        <span className="font-playfair text-stone-900">{exp.display_name}</span>
      </figcaption>
    </motion.figure>
  );
}
